<ng-container *ngIf="showBubble()">
  <div
    class="d-flex align-items-center text-primary border rounded-pill py-1 ps-3 pe-2 mt-1 mb-2 fw-bold"
    style="background-color: var(--bs-body-bg)"
  >
    <span i18n="@@reduced-bot.text" data-testid="bubble">-</span>
    <button
      style="--fof-icon-button-size: var(--fof-reduced-bot-close-bubble-button-size)"
      class="ms-2"
      data-testid="close-bubble"
      type="button"
      icon="close-reduced"
      (click)="closeBubble($event)"
      title="-"
      i18n-title="@@reduced-bot.close-bubble.hint"
    ></button>
  </div>
</ng-container>

@if (isDragDropEnabled) {
  <img
    class="mw-100 mh-100"
    data-testid="open-chat-button"
    style="width: var(--fof-reduced-bot-avatar-width); user-select: none; -webkit-user-drag: none"
    fofDragDrop
    [longPress]="true"
    (openRequested)="openChat()"
    #avatarDrag="fofDragDrop"
    [style.cursor]="avatarDrag.isDragging() ? 'grabbing' : 'pointer'"
    [src]="src"
    alt="-"
    i18n-alt="@@reduced-bot.logo"
    title="-"
    i18n-title="@@reduced-bot.open.hint"
  />
} @else {
  <img
    class="mw-100 mh-100"
    data-testid="open-chat-button"
    style="
      width: var(--fof-reduced-bot-avatar-width);
      user-select: none;
      -webkit-user-drag: none;
      cursor: pointer;
    "
    (click)="openChat()"
    (keyup.enter)="openChat()"
    [src]="src"
    alt="-"
    i18n-alt="@@reduced-bot.logo"
    title="-"
    i18n-title="@@reduced-bot.open.hint"
  />
}
